import "./async.js";
import { c as attr_class, d as clsx } from "./renderer.js";
function IconChevronDown($$renderer, $$props) {
  let { class: className = "w-4 h-4" } = $$props;
  $$renderer.push(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"${attr_class(clsx(className))}><path d="m6 9 6 6 6-6"></path></svg>`);
}
export {
  IconChevronDown as I
};
